import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { IconBase } from '../internal/IconBase.js';
/**
 * `FileText` — document with horizontal lines representing text body.
 *
 * Canonical use: text-file picker, "read more" affordance, article
 * preview tile.
 *
 * @example
 *   <FileText aria-label="text document" />
 * Aria label:    File text
 * Family:        files
 * Related:       file, file-plus, file-minus, file-x, file-check, file-download
 * Audited 2026-09-20 — no-op (5/5 criteria pass). File text.
 *
 */
export const FileText = forwardRef(function FileText(props, ref) {
    return (_jsxs(IconBase, { ref: ref, ...props, children: [_jsx("path", { d: "M14 3 H6 a2 2 0 0 0 -2 2 v14 a2 2 0 0 0 2 2 h12 a2 2 0 0 0 2 -2 V8 z" }), _jsx("path", { d: "M14 3 v5 h5" }), _jsx("path", { d: "M8 13 h8" }), _jsx("path", { d: "M8 17 h8" }), _jsx("path", { d: "M8 9 h2" })] }));
});
//# sourceMappingURL=file-text.js.map